import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Moment from 'moment';
import ReactTooltip from 'react-tooltip';
import { DISPLAY_DATE } from 'config/constants';
import S from 'calendar.scss';

const VendorBlock = ({ date, assignee }) => {
  const tooltipId = `${date.clone().format(DISPLAY_DATE)}-${assignee.id}`;
  return (<article data-tip data-for={`vendorBlock-${tooltipId}`} className={cx(S.pto)}>
    {<ReactTooltip id={`vendorBlock-${tooltipId}`} place="top" effect="solid">
      <span>Assignee has an appt. scheduled outside of your service area</span></ReactTooltip>}
    Unavailable
  </article>);
};

VendorBlock.propTypes = {
  date: PropTypes.instanceOf(Moment).isRequired,
  assignee: PropTypes.shape({ id: PropTypes.number.isRequired }).isRequired,
};

export default VendorBlock;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/schedule/components/vendorBlock.jsx